import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportProvisaoRecursosUseCase } from "../../../presentation/useCases/read/get_report_provisao_recursos_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";


export class GetReportProvisaoRecursosUseCase implements IGetReportProvisaoRecursosUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportProvisaoRecursos(
    requiredMimeType: ReportMimeType | null, DataPrevista: Date | null,
    DataRealizada: Date | null
  ): Promise<ReportData> {
    const response = await this.repository.getReportProvisaoRecursos(
      requiredMimeType, DataPrevista, DataRealizada
    );

    if (requiredMimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `ProvisaoRecursos_DataPrevista_${DataPrevista}_DataRealizada_${DataRealizada}_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
